import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { EmploymentNoteType } from './employment-note-type.interface';

const baseUrl = `/paint-employment-note-options`;

export class EmploymentNoteTypeService {
   async getEmployementNoteTypes() {
      return await http.get<Array<EmploymentNoteType>>(baseUrl, cacheFirstConfig).then((response) => response.data);
   }
}
